export default {"src":"/_next/static/media/night-life.f7c8653e.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};